import { ErrorBoundary } from '../../errorBoundary/ErrorBoundary';
import { PanelRow, ToggleControl, } from '@wordpress/components';
import { useSelect, dispatch } from '@wordpress/data';

const ItineraryPdfBookingMail = () => {
    const allData = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);
    const { updateSettings } = dispatch('WPTravel/Admin');

    const { itinerary_pdf_send_booking_mail } = typeof allData != 'undefined' && allData;

  return (
    <>
        <PanelRow className='wp-travel-itinerary-pdf-send-booking-mail' >
            <label>{_wp_travel.setting_strings.email_tempaltes.attached_itinerary_pdf}</label>
            <ToggleControl 
                help={ _wp_travel.setting_strings.email_tempaltes.attached_itinerary_pdf_note }
                checked={ typeof itinerary_pdf_send_booking_mail != 'undefined' && itinerary_pdf_send_booking_mail == true }
                onChange={ ( val ) => {

                    updateSettings({
                        ...allData,
                        itinerary_pdf_send_booking_mail: val
                    })
                }}
            />
        </PanelRow>
    </>
  )
}

export default ItineraryPdfBookingMail
